import type { AppLocale } from "./types";

type LangQ = { lang: string; q: number };

/** Parsa una stringa Accept-Language (o lista tipo navigator.languages join) e restituisce it | en. */
export function pickLocaleFromAcceptLanguage(header: string | null | undefined): AppLocale {
  const raw = (header ?? "").trim();
  if (!raw) return "it";

  const parts = raw.split(",").map((segment) => {
    const [langPart, ...params] = segment.trim().split(";").map((s) => s.trim());
    const lang = (langPart ?? "").toLowerCase();
    let q = 1;
    for (const p of params) {
      if (p.startsWith("q=")) {
        const n = parseFloat(p.slice(2));
        if (!Number.isNaN(n)) q = n;
      }
    }
    return { lang, q } satisfies LangQ;
  });

  parts.sort((a, b) => b.q - a.q);

  for (const { lang } of parts) {
    const base = lang.split("-")[0] ?? lang;
    if (base === "en") return "en";
    if (base === "it") return "it";
  }

  return "it";
}

/** Preferenze browser (stesso ordine di priorità di Accept-Language in genere). */
export function pickLocaleFromNavigator(): AppLocale {
  if (typeof navigator === "undefined") return "it";
  const list = navigator.languages?.length ? navigator.languages : [navigator.language];
  return pickLocaleFromAcceptLanguage(list.join(","));
}
